<template>
  <div class="currentBackground">
    <div class="container mx-auto px-4 py-10">
      <div class="text-center">
        <h2 class="text-3xl font-bold mb-4">Documentation</h2>
        <p class="text-lg text-gray-700 mb-6">
          Explore my santos labs documentation, where you can find hands-on guides to learn Kubernetes, Celery, FastAPI, and others from scratch.
        </p>
        
        <a target="_blank" href="https://docs.santosdev.com/" class="font-bold py-2 px-4 rounded transition duration-300" style="background:#0f172a; color:#ffffff;">
          Go to Documentation
        </a>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'DocumentationSection',
  // Other component options
};
</script>

<style scoped>
/* Add any additional styles if needed */
.currentBackground {
  --main-bg-color: #f8fafc;
  position: relative;
  background-color: var(--main-bg-color);
  overflow: hidden;
}

.currentBackground::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(99, 102, 241, 0.04); /* Subtle indigo tint triangle */
  clip-path: polygon(0 0, 100% 0, 100% 100%);
  z-index: 1;
}

</style>
